import { filter, get, isEmpty, isEqual, isNull, isUndefined, some } from "lodash";

export const filterListByZeroableId = (data: Array<any>, valueId: number | null | undefined, fieldName: string) => {

    if (isNull(valueId) || isUndefined(valueId) || valueId < 0)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName] === valueId)

    return filteredData
}

export const filterListById = (data: Array<any>, valueId: number | null | undefined, fieldName: string) => {

    if (isNull(valueId) || isUndefined(valueId) || valueId <= 0)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName] === valueId)

    return filteredData
}

export const filterListByObject = (data: Array<any>, value: any, fieldName: string) => {

    if (isNull(value) || isUndefined(value))
        return data;

    const filteredData = filter(data, (d: any) => isEqual(d[fieldName], value))

    return filteredData
}

export const filterListByDate = (data: Array<any>, value: Date, fieldName: string) => {

    if (isNull(value) || isUndefined(value))
        return data;

    const filteredData = filter(data, (d: any) => {
        let field = d[fieldName] as Date
        return isEqual(field.toLocaleDateString(), value.toLocaleDateString())
    })

    return filteredData
}

export const filterListByArrayOfObject = (data: Array<any>, values: Array<any>, fieldName: string) => {

    if (values.length <= 0)
        return data;

    const filteredData = filter(data, (d: any) => some(values, d[fieldName]))

    return filteredData
}

export const filterListByUnmatchId = (data: Array<any>, valueId: number | null | undefined, fieldName: string, showData: boolean) => {

    if (showData)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName] !== valueId)

    return filteredData
}

export const filterListByUnmatchNestedId = (data: Array<any>, valueId: number | null | undefined, fieldName: string, nestedFieldName: string, showData: boolean) => {

    if (showData)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName][nestedFieldName] !== valueId)

    return filteredData
}

export const filterListByMatchId = (data: Array<any>, valueId: number | null | undefined, fieldName: string, showData: boolean) => {

    if (!showData)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName] === valueId)

    return filteredData
}

export const filterListByMatchNestedId = (data: Array<any>, valueId: number | null | undefined, fieldName: string, nestedFieldName: string, showData: boolean) => {

    if (!showData)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName][nestedFieldName] === valueId)

    return filteredData
}

export const filterListByUnsetId = (data: Array<any>, activateFilter: boolean, fieldName: string) => {

    if (isNull(activateFilter) || isUndefined(activateFilter) || !activateFilter)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName] <= 0 || isNull(fieldName) || isUndefined(fieldName))

    return filteredData
}

export const filterListArrayByArrayOfId = (data: Array<any>, values: Array<number>, fieldName: string) => {

    if (values.length <= 0)
        return data;

    const filteredData = filter(data, (d: any) => values.some(r => d[fieldName] === r))

    return filteredData
}

export const filterListArrayByArrayOfObject = (data: Array<any>, values: Array<any>, fieldName: string) => {

    if (values.length <= 0)
        return data;

    const filteredData = filter(data, (d: any) => some(d[fieldName], d => some(values, d)))

    return filteredData
}

export const filterListByText = (data: Array<any>, searchText: string, fieldNames: Array<string>) => {

    if (isEmpty(searchText) || fieldNames.length === 0 || data.length === 0)
        return data;

    const filteredData = filter(data, (d: any) => fieldNames.some(fieldName => get(d, fieldName)?.toString().toLowerCase().includes(searchText.toLowerCase())))

    return filteredData
}

export const markAsSelected = (data: Array<any>, valueId: number | null | undefined, fieldName: string) => {

    if (isNull(valueId) || isUndefined(valueId) || valueId <= 0)
        return data;

    const markedData = data.map(d => ({ ...d, selected: d[fieldName] === valueId }))

    return markedData
}

export const filterListByBooleanTrue = (data: Array<any>, value: boolean, fieldName: string) => {

    if (isNull(value) || isUndefined(value) || !value)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName] === value)

    return filteredData
}

export const filterListByBooleanFalse = (data: Array<any>, value: boolean, fieldName: string) => {

    if (isNull(value) || isUndefined(value) || value)
        return data;

    const filteredData = filter(data, (d: any) => d[fieldName] === value)

    return filteredData
}

export const filterListByBoolean = (data: Array<any>, value: boolean, fieldName: string) => {

    const filteredData = filter(data, (d: any) => d[fieldName] === value)

    return filteredData
}
